import { ORGANISATION_ID } from '@shootsta/common-domain-data';

export default function isShootstaOrgId(orgId) {
  return ORGANISATION_ID.SHOOTSTA === orgId;
}